export default function getArenaSubStatus({
  isInitialisingCombat = false,
  arena_status = '',
  arena_ended = false,
  toggleNumbers = false,
  awaitingRollOffs = false,
  arena_rolled = false,
  arena_extra_ready = false,
  arena_extra_action = 0,
  arena_bleeders_ready = false,
  arena_round_completed = false,
}) {
  if (isInitialisingCombat) {
    return 'Initialising Combat'
  }

  if (arena_status == 'Inactive') {
    if (arena_ended) {
      return 'Ended'
    }

    if (awaitingRollOffs) {
      return 'Awaiting Roll-Offs'
    }

    if (toggleNumbers) {
      return 'Rolling Strike Ranks'
    }

    if (arena_rolled) {
      return 'Waiting to Start Combat'
    }

    return 'Awaiting Strike Ranks'
  }

  if (awaitingRollOffs) {
    return 'Awaiting Roll-Offs'
  }

  if (toggleNumbers && !arena_rolled) {
    return 'Rolling Strike Ranks'
  }

  if (arena_extra_ready) {
    return 'Awaiting Extra Attacks'
  }

  if (arena_extra_action > 0) {
    return 'Extra Attacks In Progress'
  }

  if (arena_bleeders_ready) {
    return 'Awaiting Bleeders'
  }

  if (arena_round_completed) {
    return 'Awaiting New Round'
  }

  if (!arena_rolled) {
    return 'Awaiting Strike Ranks'
  }

  return 'Combat In Progress'
}
